
  import * as noneRuntime$Vsr5zkhUI_45Bl_8_45Bj1L6aQgFKfduZktGD0h7QMNKGzw from '/app/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.9.2_magicast@0.5.1/node_modules/@nuxt/image/dist/runtime/providers/none'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['none']: { provider: noneRuntime$Vsr5zkhUI_45Bl_8_45Bj1L6aQgFKfduZktGD0h7QMNKGzw, defaults: {} }
    }
  }
